import { render, staticRenderFns } from "./CompGeneralShowMore.vue?vue&type=template&id=7a60fd4a"
import script from "./CompGeneralShowMore.vue?vue&type=script&setup=true&lang=js"
export * from "./CompGeneralShowMore.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports